import { defineMessages } from "react-intl";

import { FORM_VERSION_V5 } from "./constants";

const translations = defineMessages({
  invalidConfigurationFile: {
    id: "importConfigFromFile.invalidConfigurationFile",
    defaultMessage: "Invalid configuration file. Missing channelConfig property.",
  },
  configurationVersionMismatch: {
    id: "importConfigFromFile.configurationVersionMismatch",
    defaultMessage: "Configuration version mismatch - expected version 5.0",
  },
  invalidJsonFile: {
    id: "importConfigFromFile.invalidJsonFile",
    defaultMessage: "Invalid JSON file. Please check the file format.",
  },
  errorReadingFile: {
    id: "importConfigFromFile.errorReadingFile",
    defaultMessage: "Error reading file. Please try again.",
  },
});

export default function importConfigFromFile(file, setImportedConfig, errorNotification) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const jsonString = event.target.result;
        const importedData = JSON.parse(jsonString);

        if (!importedData.channelConfig) {
          errorNotification(translations.invalidConfigurationFile);
          reject(new Error(translations.invalidConfigurationFile.defaultMessage));

          return;
        }

        if (importedData.version && importedData.version !== FORM_VERSION_V5) {
          errorNotification(translations.configurationVersionMismatch);
          reject(new Error(translations.configurationVersionMismatch.defaultMessage));
        }

        setImportedConfig(importedData.channelConfig);

        resolve(importedData);
      } catch (parseError) {
        errorNotification(translations.errorReadingFile);
        reject(new Error(translations.errorReadingFile.defaultMessage));
      }
    };

    reader.onerror = () => {
      errorNotification(translations.errorReadingFile);
      reject(new Error(translations.errorReadingFile.defaultMessage));
    };

    reader.readAsText(file);
  });
}
